import { action, thunk } from 'easy-peasy';
import * as service from './services';

const unsplashModel = {
	searchValue: 'background',
	images: [],
	totalPages: 0,
	searchPage: 1,

	setImages: action((state, images) => {
		state.images = images;
	}),
	setTotalPages: action((state, totalPages) => {
		state.totalPages = totalPages;
	}),
	setSearchValue: action((state, searchValue) => {
		state.searchValue = searchValue;
	}),
	setSearchPage: action((state, searchPage) => {
		state.searchPage = searchPage;
	}),
	searchImages: thunk(async (actions, payload, { getState }) => {
		// call our service
		// then dispatch an action to update state
		// console.log('searchImages getState', getState());
		const { inputSearchValue, searchPage } = payload;
		const searchValue = inputSearchValue || getState().searchValue;
		const finalSearchPage = searchPage || getState().searchPage;
		const data = await service.searchImages({
			inputSearchValue: searchValue,
			searchPage: finalSearchPage,
		});
		if (data) {
			const { results, total_pages } = data;
			actions.setImages(results);
			actions.setTotalPages(total_pages);
			actions.setSearchValue(searchValue);
			actions.setSearchPage(finalSearchPage);
		}
	}),
};

export default unsplashModel;
